import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/semantic-platform/data-governance/classifications/")({
  component: LegacyClassificationsRedirect,
});

/** 分类配置已并入标签中心（统一标签体系 D1：一个模块管定义+绑定+审核） */
function LegacyClassificationsRedirect() {
  return <Navigate to="/semantic-platform/tag-center/fields" replace />;
}
